import {PURCHASE_DECISION} from '../actions/index';
export default function (state = null, action) {

  switch (action.type) {
    case PURCHASE_DECISION:
      return action.payload.data;
    default:
      break;
  }
  return state;
}
